import script from "./QuoteGenerationView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteGenerationView.vue?vue&type=script&setup=true&lang=js"

import "./QuoteGenerationView.vue?vue&type=style&index=0&id=3b07da73&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b07da73"]])

export default __exports__